import { Stack, Button } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { primaryButtonSx, outlinedButtonSx } from "../../styles/cyberTheme";

export default function MemberPanelActions({ onSwitchLogin }) {
    const navigate = useNavigate();

    const handleSwitchLogin = () => {
        onSwitchLogin?.();
    };

    const handleBackToMain = () => {
        navigate("/dashboard");
    };

    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
            <Button
                variant="outlined"
                startIcon={<GridViewIcon />}
                onClick={handleSwitchLogin}
                sx={{ ...outlinedButtonSx, fontSize: "14px", py: 0.75 }}
            >
                切換其他參加者
            </Button>
            <Button
                variant="contained"
                startIcon={<LogoutIcon />}
                onClick={handleBackToMain}
                sx={{ ...primaryButtonSx, fontSize: "14px", py: 0.75 }}
            >
                返回主頁
            </Button>
        </Stack>
    );
}
